import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {SharedService} from "./sharedService";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class ExternalApiGatewayService {

    constructor(private http: HttpClient,
                private sharedService: SharedService) {}
    getList$(): Observable<any> {
        return this.http.get<any>(this.sharedService.apiUrl('api/external-api', ""));
    }

    paging$(query: string): Observable<any> {
        return this.http.get<any>(this.sharedService.apiUrl('api/external-api/paging', query));
    }

    upsert$(apiData: any): Observable<any> {
        return this.http.post<any>(this.sharedService.apiUrl('api/external-api'), apiData, httpOptions).pipe(
            catchError(this.sharedService.handleError<any>('external-api-upsert$'))
        );
    }

    get$(id: string): Observable<any> {
        return this.http.get<any>(this.sharedService.apiUrl(`api/external-api/${id}`))
    }

    delete$(id: any): Observable<any> {
        return this.http.delete<any>(this.sharedService.apiUrl('api/external-api', id), httpOptions).pipe(
            catchError(this.sharedService.handleError<any>('delete-external-api-delete$'))
        );
    }

    fetchMetaData$(apiId: string): Observable<any> {
        return this.http.get<any>(this.sharedService.apiUrl(`api/external-api/fetch-meta-data/${apiId}`)).pipe(
            catchError(this.sharedService.handleError<any>('external-api-fetch-data$'))
        );
    }

    fetchData$(fileFormatId: string): Observable<any> {
        return this.http.get<any>(this.sharedService.apiUrl(`api/external-api/fetch-data/${fileFormatId}`)).pipe(
            catchError(this.sharedService.handleError<any>('external-api-fetch-data$'))
        );
    }

    columns: Array<any> = [
        {key: 'view', style: {'flex': '0 0 100px', 'width': '1%'}, button: true},
        {name: 'Name', tag: 'SERVICE-API.NAME', key: 'name', filtering: true, sorting: true, sortingOrder: 'asc'},
        {name: 'URL', tag: 'SERVICE-API.URL', key: 'url', filtering: true, sorting: true},
        //{name: 'Type', tag: 'SERVICE.TYPE', key: 'type', filtering: true, sorting: true}
    ];

    getMetaInfo(): string[] {
        return ['name', 'url'];
    }

    getColumns(): string[] {
        return this.columns;
    }

}
